export default __webpack_public_path__ + "static/media/contact.d40c934d.jpg";